// Embalagens disponíveis no catálogo que a aplicação não conseguiu atualizar (a API manda por
// cálculo em skus_disponiveis_nao_atualizados). Sem aviso, a tela diria só "Preços aplicados".
import { PRICING_CATALOG_NAMES } from "./mocks";

const nomeDoCatalogo = catalogId =>
  PRICING_CATALOG_NAMES[catalogId] ?? `catálogo ${catalogId}`;

export const avisoSkusNaoAtualizados = (rows, calcs) => {
  const partes = (calcs || [])
    .map((calc, i) => ({ calc, row: rows[i] }))
    .filter(
      ({ calc }) =>
        calc && !calc.error && calc.skus_disponiveis_nao_atualizados?.length
    )
    .map(({ calc, row }) => {
      const nome = row?.nome_produto ?? `Produto ${calc.product_base_id}`;
      const skus = calc.skus_disponiveis_nao_atualizados
        .map(s => `SKU ${s.prod_sku} (${nomeDoCatalogo(s.catalog_id)})`)
        .join(", ");
      return `${nome}: ${skus}`;
    });
  return partes.length ? partes.join("; ") : null;
};
